/**
 * Updates document title and PWA meta tags with tenant-specific name.
 * The manifest itself is served from the backend API (/v2/manifest) and derived from the Referer.
 * This keeps the in-tab title and meta tags in sync when the app loads.
 * @param {object} store - Vuex store (must have tenant.tenantinfo populated)
 */
export function updateDynamicManifest(store) {
  const tenantinfo = store?.state?.tenant?.tenantinfo;
  if (!tenantinfo || !tenantinfo.tenantname) {
    return;
  }

  const name = tenantinfo.title || tenantinfo.tenantname;
  document.title = name;

  const setMeta = (metaName, content) => {
    let meta = document.querySelector(`meta[name="${metaName}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = metaName;
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  };
  setMeta('apple-mobile-web-app-title', name);
  setMeta('application-name', name);
}
